import { httpGet, httpPost, httpPut } from '../httpCalls';
import { createDownloadableFile, updateDownloadableFile } from '../../actions/downloadableFileActions';
import { createBackgroundFile, updateBackgroundFile } from '../../actions/backgroundFileActions';
import { reloadError, resetError } from '../../actions/errorActions';
/* eslint-disable import/prefer-default-export */


export const mapDispatchToProps = (dispatch) => ({

  resetForm: () => dispatch(resetError()),

  getItemDonwloadable: async (id) => {
    // console.log("mmmm",id);
    const downloadableItem = await httpGet(`downloadable/${id}`);
    dispatch(createDownloadableFile(downloadableItem));
    return downloadableItem;
  },

  getBackground: async (id) => {
    const downloadableItem = await httpGet(`background/${id}`);
    dispatch(createBackgroundFile(downloadableItem));
    return downloadableItem;
  },

  saveItemDownloadable: (data) => {
    if (data.id === undefined) {
      return httpPost('downloadable', data)
        .then((downloadableItem) => {
          dispatch(createDownloadableFile(downloadableItem));
          dispatch(resetError());
          return downloadableItem;
        }, (error) => {
          dispatch(reloadError(error));
          return Promise.reject(error);
        });
    }

    return httpPut(`downloadable/${data.id}`, data)
      .then((downloadableItem) => {
        dispatch(updateDownloadableFile(downloadableItem));
        dispatch(resetError());
        return downloadableItem;
      }, (error) => {
        dispatch(reloadError(error));
        return Promise.reject(error);
      });
  },

  saveItemBackground: (data) => {
    if (data.id === undefined) {
      return httpPost('background', data)
        .then((downloadableItem) => {
          dispatch(createBackgroundFile(downloadableItem));
          dispatch(resetError());
          return downloadableItem;
        }, (error) => {
          dispatch(reloadError(error));
          return Promise.reject(error);
        });
    }

    return httpPut(`background/${data.id}`, data)
      .then((downloadableItem) => {
        dispatch(updateBackgroundFile(downloadableItem));
        dispatch(resetError());
        return downloadableItem;
      }, (error) => {
        dispatch(reloadError(error));
        return Promise.reject(error);
      });
  },
});
